import { API_BASE, apiFetch } from "../../api/http";

// Structured issue type returned by clause check
export interface ClauseIssue {
  anchor: string;
  paragraph: string;
  analysis: string;
  currentText: string;
  correction: string;
}

// Response type for clause check (includes sessionId for batch operations)
export interface ClauseCheckResponse {
  analysis: string;  // Bullet-formatted text (for backwards compatibility)
  issues?: ClauseIssue[];  // Structured issues array
  sessionId?: string;
}

// Response type for batch refine
export interface RefineBatchResult {
  anchor: string;
  analysis: string | null;
  cached?: boolean;
  error?: string;
}

export interface RefineBatchResponse {
  results: RefineBatchResult[];
}

export async function postClauseCheck(body: Record<string, any>): Promise<ClauseCheckResponse> {
  const res = await apiFetch(`${API_BASE}/api/clauseCheck`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error(`clauseCheck failed: ${res.status}`);
  return res.json();
}

export async function postClauseCheckRefine(body: {
  prompt?: string;
  docContent?: string;
  anchor?: string;
  jurisdiction?: string;
  clientName?: string;
  projectNumber?: string;
  documentType?: string;
  sessionId?: string;
}): Promise<{ analysis: string }> {
  const res = await apiFetch(`${API_BASE}/api/clauseCheck/refine`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error(`clauseCheck/refine failed: ${res.status}`);
  return res.json();
}

// Batch refine endpoint - processes multiple anchors in one request
// This is the primary method for prefetching all clause corrections
export async function postClauseCheckRefineBatch(body: {
  sessionId?: string;
  anchors: string[];
  docContent?: string;
  jurisdiction?: string;
  clientName?: string;
  projectNumber?: string;
  documentType?: string;
}): Promise<RefineBatchResponse> {
  const res = await apiFetch(`${API_BASE}/api/clauseCheck/refineBatch`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error(`clauseCheck/refineBatch failed: ${res.status}`);
  return res.json();
}
